import React from "react";
import { get } from "lodash";
import { useTranslation } from "react-i18next";

import Preloader from "~/components/Preloader";
import { useGetLocationData } from "~/hooks/locationData";
import { useGetUploadLogByIdQuery } from "~/schemas/generated/graphql";
import { pickLocalized } from "~/shared/lib/pickLocalized";

import s from "./UploadErrorsList.less";

const UploadErrorsList = () => {
  const { t } = useTranslation();
  const language = localStorage.getItem("language");
  const { currentId } = useGetLocationData();
  const { data, loading } = useGetUploadLogByIdQuery({
    variables: {
      id: currentId,
    },
    fetchPolicy: "no-cache",
    skip: !currentId,
  });

  const { errors = [] } = get(data, "IndicatorGetter.getUploadLogById") || {};

  return (
    <>
      {loading ? (
        <Preloader />
      ) : (
        <div className={s.scrollable}>
          {errors.length > 0
            ? errors.map(({ level, x, y, descEn, desc }) => (
                <div
                  className={`${s.item} ${
                    level === "warning" ? s.redLevel : ""
                  }`}
                  key={`${x}-${y}-${level}`}
                >
                  {pickLocalized(desc, descEn, language === "en")}
                </div>
              ))
            : t("uploads.no_logs")}
        </div>
      )}
    </>
  );
};

export default UploadErrorsList;
